import React from 'react';
import PropTypes from 'prop-types';

import {
  Box,
  CircularProgress,
  Typography,
} from '@material-ui/core';

import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexFlow: 'row',
    alignItems: 'center',
  },
  label: {
  },
}));

const StatusAdornment = (props) => {
  const { status, tasks, adornment } = props;
  
  const adornmentStyle=adornment==='start'? { marginRight: '8px' } : { marginLeft: '8px' };
  if(tasks && (status==='RUNNING')) {

    const started=tasks.Started || 0;
    const stopped=tasks.Stopped || 0;
    const running=started-stopped;
    
    const thickness=Math.max(Math.min(running/4,8),1);

    return(running?
      <Box position="relative" display="inline-flex" style={adornmentStyle}>
        <CircularProgress size={20} thickness={thickness}/>
        <Box
          top={0}
          left={0}
          bottom={0}
          right={0}
          position="absolute"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <Typography variant="caption" component="div" style={{ fontSize: '.6rem', fontWeight: 'bold'}}>{Math.round(running)}</Typography>
        </Box>
      </Box>    
      :null
    );
    
  } else {
    return(null);
  }
};

export default function ExecutionStatus(props) {

  const { execution, adornment } = props;
  
  const classes = useStyles();

  if(!execution){
    return(null);  
  }

  const status=execution.Status;
  const tasks=execution.Tasks;
  
  return(
    <div className={classes.root}>
      {adornment==='start'?<StatusAdornment { ...{status, tasks, adornment}}/>:null}
      <Typography variant='body2' className={classes.label}>{status}</Typography>
      {adornment==='end'?<StatusAdornment {...{status, tasks, adornment}}/>:null}
    </div>
  );

}

ExecutionStatus.propTypes = {
  execution: PropTypes.object,
  adornment: PropTypes.oneOf(['none','start','end']).isRequired,
};

ExecutionStatus.defaultProps = {
  adornment: 'start'
};

